import styled from "@emotion/styled";
import { transparentize, padding } from "polished";
import React from "react";

import { Container } from "@brexhq/next/src/components/layout/Container/Container";
import { Link } from "@brexhq/next/src/components/shared/Link";

import ModuleRenderer from "../../ModuleRenderer";
import type { INavModuleProps, IGroupNavModule } from "../../types";

const InnerContainer = styled(Container)(({ theme }) => ({
  borderBottom: `1px solid ${transparentize(
    0.8,
    theme.colors.content.tertiary,
  )}`,
  ...padding(theme.spacing.LRG.xxsml, 0),
  [theme.breakpoints.nav.SML]: {
    ...padding(theme.spacing.SML.xxsml, theme.spacing.SML.sml),
  },
}));

const Heading = styled.h3(({ theme }) => ({
  ...theme.typography.BodySmallSB,
}));

export default function GroupNavModule({
  title,
  link,
  modules,
  span = 1,
}: INavModuleProps<IGroupNavModule>) {
  return (
    <Container display="flex" direction="column" gap="sml">
      <InnerContainer display="flex" justifyContent="space-between">
        <Heading>{title}</Heading>
        {link && (
          <Link
            to={link.link.to || link.link.toExternal || link.link.hash || "#"}
            noFollow={link.link.noFollow}
            label={link.text}
            modifier="arrow"
            component="navGroup link"
            // remove this from tab order since this will be controlled
            // exclusively by arrow keys.
            tabIndex={-1}
            size={{
              LRG: "DEVIATED_NAV_SIZE",
              MED: "DEVIATED_NAV_SIZE",
              SML: "DEVIATED_NAV_SIZE",
            }}
          />
        )}
      </InnerContainer>
      <ModuleRenderer modules={modules} span={span} />
    </Container>
  );
}
